import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getInitialRoute } from "../../../../../utils";
import { Helmet } from "react-helmet";
import { shallowEqual, useSelector } from "react-redux";
import { MediaBaseUrl } from "../../../../../actions/api";

export default function Success() {
    const [payAnimation, setpayAnimation] = useState(false);
    const { userData } = useSelector(state => state.authenticated, shallowEqual);   
    const [planDetails, setPlanDetails] = useState({
        planName: '',
        planValue: '',
        tnxId: '',
        currency: '',
        items: []
    });
    const trackingId = `AW-11467357521/${getInitialRoute() != 'widget' ? 'yi4TCJGG_IYZENH6h9wq' : 'VM2lCLP7_YYZENH6h9wq'}`;

    useEffect(() => {

        setTimeout(() => {
            setpayAnimation(true);
        }, 500);

        if(window.location.host.includes('app') && window.fpr && userData && userData.user && Object.keys(userData.user).length > 0 && !userData.user.emailId.includes('taggbox.com')){
            window.fpr("referral",{email: userData.user.emailId})
        }

        const userPlanDetails = JSON.parse(localStorage.getItem('planDetails'));
            if(userPlanDetails && Object.keys(userPlanDetails).length > 0){
                const { planName, planValue, tnxId, currency, purchased } = userPlanDetails;
                setPlanDetails(prevState => ({ ...prevState, currency: currency, planName: planName, planValue: planValue, tnxId: tnxId, items: purchased }));
            }
        localStorage.removeItem('planDetails');
    }, []);

    return (<>
        {(window.location.host.includes('app') && planDetails.planValue != "" && planDetails.tnxId != "" && planDetails.currency != "") ? <Helmet>
            <script async src="https://www.googletagmanager.com/gtag/js?id=AW-919733403"></script>
            <script type="text/javascript">
                {`gtag('event', 'conversion', {
                  'send_to': 'AW-919733403/ReCpCLvWr5gBEJuJyLYD',
                  'value': ${planDetails.planValue},
                  'currency': '${planDetails.currency}',
                  'transaction_id': '${planDetails.tnxId}'
              });`}
            </script>
            <script type="text/javascript">
                {`gtag('event', 'conversion', {
                  'send_to': '${trackingId}',
                  'value': ${planDetails.planValue},
                  'currency': '${planDetails.currency}',
                  'transaction_id': '${planDetails.tnxId}'
             });`}
            </script>
            <script type="text/javascript">
                {`gtag('event', 'purchase', {
                    'transaction_id': '${planDetails.tnxId}',
                    'value': ${planDetails.planValue},
                    'currency': '${planDetails.currency}',
                    items: ${JSON.stringify(planDetails.items)}
                });`}
            </script>
        </Helmet> : null}
        <div className="d-flex flex-column flex-root" style={{ minHeight: 'calc(100vh - 65px)' }}>
            <div className="d-flex flex-row-fluid">
                <div className="small_container d-flex flex-row-fluid flex-column justify-content-center p-5 text-center">
                    <div className={`upgrade_succ_wrap p-5 position-relative f-center ${payAnimation ? 'active' : ''}`}>
                        <div className="upgrade_succ">
                            <img src={`${MediaBaseUrl}success/upgrade-account-bg.svg`} className="img-fluid" alt="" />
                        </div>
                        <img src={`${MediaBaseUrl}success/Upgrade-Account.svg`} className="img-fluid position-relative" alt="" />
                    </div>
                    <h2 className="font-weight-boldest mb-4 display-5">Congratulations 🎉 🎉</h2>
                    
                    <p className="font-size-h6">{planDetails.planName == 'StartUp plan' ? 'You have transitioned to ' : 'You have successfully upgraded to '}<span className="text-gradient font-weight-boldest">{planDetails.planName}</span>.</p>
                    <p className="font-size-h6">Explore new possibilities &amp; features now</p>
                    <div className="mt-3">
                        <Link to={`/walls/home`} className="btn btn-primary btn-lg btn-min-w">Explore Now</Link> </div>
                </div>
            </div>
        </div>
    </>
    )
}